module.exports = __webpack_public_path__ + "static/media/img31.406b6acf.jpg";